import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface UpdateDeviceProfileRequest {
  id: string;
  name?: string;
  mapMarkerIcon?: string | null;
}

interface UpdateDeviceProfileResponse {
  name: string | null;
  mapMarkerIcon: string | null;
}

/**
 * API call to update device profile.
 */
const updateDeviceProfile = 
  async (request: UpdateDeviceProfileRequest): Promise<UpdateDeviceProfileResponse | null> => {
    const response: any = await customFetchV2<UpdateDeviceProfileResponse>(`/api/device_profiles/${request.id}`, {
      method: 'PUT',
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Unable to update device profile');
    }

    return response.data;
  };

const useUpdateDeviceProfileMutation = () => {
  return useMutation({
    mutationFn: updateDeviceProfile,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useUpdateDeviceProfileMutation };
